import script from "./ChartHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ChartHeader.vue?vue&type=style&index=0&id=193945ff&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193945ff"]])

export default __exports__